import { render, staticRenderFns } from "./csv-form.vue?vue&type=template&id=bb245542&scoped=true"
import script from "./csv-form.vue?vue&type=script&lang=ts"
export * from "./csv-form.vue?vue&type=script&lang=ts"
import style0 from "./csv-form.vue?vue&type=style&index=0&id=bb245542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb245542",
  null
  
)

export default component.exports